// extracted by mini-css-extract-plugin
module.exports = {"cityList":"styles-module--cityList--7n3_s"};